import React from 'react';

import svg from './assets/icons-24-diamond.svg';
import type { IconProps } from './SvgIcon';
import { SvgIcon } from './SvgIcon';

export const IconDiamond = (props: IconProps) => (
  <SvgIcon {...props} src={svg} testId="icon-diamond" />
);
